import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, Route, Switch } from 'react-router-dom';
import { setAuthState, getAuthSessionStateToken } from '../../redux/reducers/auth/auth.actions';
import api from '../../api';
import AppConfig from '../../config';
import AppHeader from '../../components/app-header/app-header';
import Login from '../../components/login/login';
import Logout from '../../components/login/logout';
import Unauthorized from '../../components/login/unauthorized';
import PageNotFound from '../../components/page-not-found/page-not-found';
import LoadingView from '../../views/loading/loading-view';
import ComingSoonManageView from '../../views/coming-soon/coming-soon-manage-view';
import ComingSoonEditView from '../../views/coming-soon/coming-soon-edit-view';
import DashboardMainView from '../dashboard/dashboard-main-view';
import MoviesListView from '../movies/movies-list-view';
import MovieEditView from '../movies/movie-edit-view';
import TheaterListView from '../theaters/theater-list-view';
import TheaterEditView from '../theaters/theater-edit-view';
import NewsListView  from '../news/news-list-view';
import NewsEditView  from '../news/news-edit-view';
import UserListView from '../users/user-list-view';
import UserEditView from '../users/user-edit-view';
import ScheduleListView from '../schedules/schedule-list-view';
import ScheduleEditView from '../schedules/schedule-edit-view';
import FaIcon from '../../components/global/fa-icon/fa-icon';



class MovieManager extends Component {

  constructor(props) {
    super(props);

    // NOTE: print out the app info data for testing.
    // console.log(JSON.stringify({ ...AppConfig.appInfo, env: AppConfig.env }, null, 2));

    this.state = {
      modal: true,
      loading: true,
      showLoadView: false
    };

    // if the app has not finished loading after N seconds, then allow the loading page to show
    // this is to prevent a flicker during init. if the app loads fast enough, then we don't need to show the pre-loader
    setTimeout(() => {
      if (this.state.loading) {
        this.setState({ showLoadView: true });
      }
    }, 3000);

    this.initializeAppState()
  }

  async initializeAppState() {
    let authToken = getAuthSessionStateToken();
    // console.log('ls.auth: ' + authToken);
    if (authToken) {
      api.config.authToken = authToken;
    }
    let authStatus = await api.auth.status();
    // console.log('auth status: ' + JSON.stringify(authStatus, null, 2));


    let session = _.get(authStatus, 'data.session', null);
    let profile = _.get(authStatus, 'data.profile', null);
    if (session && profile) {
      this.props.setAuthState(session, profile, false);
    }

    this.setState({ loading: false });
  }

  render() {

    if (this.state.loading) {
      return this.state.showLoadView? this.renderLoadingView(): null;
    }

    let isLoggedIn = this.props.auth.isLoggedIn;

    return (
      <div className={'movie-manager ' + (isLoggedIn? 'logged-in': 'logged-out')}>
        <div className="backdrop"></div>
        <div className="header">
          <AppHeader />
        </div>
        <div className="main">
          { this.renderMainView() }
        </div>
        <div className="footer">
          { this.renderFooterView() }
        </div>
      </div>
    );
  }

  renderLoadingView() {
    return <LoadingView />;
  }

  renderMainView() {

    let isLoggedIn = this.props.auth.isLoggedIn;
    if (!isLoggedIn) {
      return (
        <div className="main-body">
          <div className="main-content">
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/logout" component={Logout} />
              <Route component={Unauthorized} />
            </Switch>
          </div>
        </div>
      );
    }

    return (
      <div className="main-body">
        <div className="sidebar">
          {this.renderNavSidebar()}
        </div>
        <div className="main-content">
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/logout" component={Logout} />
            <Route exact path="/" component={DashboardMainView} />
            <Route exact path="/schedules" component={ScheduleListView} />
            <Route exact path="/schedules/edit/:id" component={ScheduleEditView} />
            <Route exact path="/schedules/copy/:sourceScheduleId" component={ScheduleEditView} />
            <Route exact path="/schedules/add" component={ScheduleEditView} />
            <Route exact path="/coming-soon" component={ComingSoonManageView} />
            <Route exact path="/coming-soon/edit/:id" component={ComingSoonEditView} />
            <Route exact path="/coming-soon/add-movie/:movieId" component={ComingSoonEditView} />
            <Route exact path="/coming-soon/add" component={ComingSoonEditView} />
            <Route exact path="/movies" component={MoviesListView} />
            <Route exact path="/movies/edit/:id" component={MovieEditView} />
            <Route exact path="/movies/add" component={MovieEditView} />
            <Route exact path="/theaters" component={TheaterListView} />
            <Route exact path="/theaters/edit/:id" component={TheaterEditView} />
            <Route exact path="/news" component={NewsListView} />
            <Route exact path="/news/edit/:id" component={NewsEditView} />
            <Route exact path="/news/add" component={NewsEditView} />
            <Route exact path="/users" component={UserListView} />
            <Route exact path="/users/edit/:id" component={UserEditView} />
            <Route exact path="/users/add" component={UserEditView} />
            {/* <Route component={DashboardMainView} /> */}
            <Route render={() => this.renderDefaultView()} />
          </Switch>
        </div>
      </div>
    );
  }

  renderNavSidebar() {
    return (
      <div className="nav-sidebar nav">
        <NavLink className="nav-item" activeClassName="selected" exact to="/">
          <div className="icon"><FaIcon icon="fa-home-alt" /></div>
          <div className="label">Dashboard</div>
        </NavLink>
        <NavLink className="nav-item" activeClassName="selected" to="/movies">
          <div className="icon"><FaIcon icon="fa-film-alt" /></div>
          <div className="label">Movies</div>
        </NavLink>
        <NavLink className="nav-item" activeClassName="selected" to="/coming-soon">
          <div className="icon"><FaIcon icon="fa-alarm-clock" /></div>
          <div className="label">Coming Soon</div>
        </NavLink>
        <NavLink className="nav-item" activeClassName="selected" to="/schedules">
          <div className="icon"><FaIcon icon="fa-calendar-alt" /></div>
          <div className="label">Schedules</div>
        </NavLink>
        <NavLink className="nav-item" activeClassName="selected" to="/news">
          <div className="icon"><FaIcon icon="fa-newspaper" /></div>
          <div className="label">News</div>
        </NavLink>
        <NavLink className="nav-item" activeClassName="selected" to="/theaters">
          <div className="icon"><FaIcon icon="fa-hotel" /></div>
          <div className="label">Theaters</div>
        </NavLink>
        <NavLink className="nav-item" activeClassName="selected" to="/users">
          <div className="icon"><FaIcon icon="fa-user-friends" /></div>
          <div className="label">Users</div>
        </NavLink>


        {/*
        <div className="nav-item">
          <NavLink activeClassName="selected-link" exact to="/">
            <button className="btn">
              Home
            </button>
          </NavLink>
        </div>
        <div className="nav-item">
          <NavLink activeClassName="selected-link" to="/login">Login</NavLink>
        </div>
        <div className="nav-item">
          <NavLink activeClassName="selected-link" to="/logout">Logout</NavLink>
        </div>
        <div className="nav-item">
          <NavLink activeClassName="selected-link" to="/foobar">FooBar</NavLink>
        </div>
        */}

      </div>
    );
  }

  renderDefaultView(title = 'Page Not Found') {
    return (
      <div>
        <PageNotFound title={title} />
        { AppConfig.dbgMode? (
          <div>
            <h4>Debug State:</h4>
            <pre>
                { JSON.stringify(this.props.auth, null, 2) }
            </pre>
          </div>
        ): null }
      </div>
    );
  }

  renderFooterView() {
    return (
      <div className="fillxy d-flex flex-row justify-content-center align-items-center center-text">

        {/*
        <NavLink activeClassName="selected-link" exact to="/">Home</NavLink> &nbsp;|&nbsp;
        <NavLink activeClassName="selected-link" to="/login">Login</NavLink> &nbsp;|&nbsp;
        <NavLink activeClassName="selected-link" to="/logout">Logout</NavLink> &nbsp;|&nbsp;
        */}

        { AppConfig.copyright }

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  setAuthState,
  // getAuthSessionStateToken,
};

export default connect(mapStateToProps, mapDispatchToProps)(MovieManager);
